import { VersionsSchema } from "@/schemas/versions.schema";
import { cbHttp } from "./http.service"
import { z } from "zod";

export const getVersionsWithSubversions = async (): Promise<z.infer<typeof VersionsSchema>[]> => {
    return cbHttp.get(`/api/versions/versionwithsubversions`);
}

export const CreateVersion = async (data: FormData): Promise<boolean> => {
    return cbHttp.post(`/api/versions/createversion`, data);
}